import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

const ProcessSlider = ({ steps }) => {
  const [currentStep, setCurrentStep] = useState(0);

  // Auto-slide every 4 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % steps.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [steps.length]);

  return (
    <div className="md:hidden">
      {/* Slider Container */}
      <div className="relative overflow-hidden">
        <div 
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${currentStep * 100}%)` }}
        >
          {steps.map((step) => (
            <div key={step.step} className="w-full flex-shrink-0 px-4">
              <div className="bg-slate-900 border border-white/20 rounded-lg p-6 mx-auto max-w-sm hover:border-white/40 hover:shadow-lg hover:shadow-amber-500/20 hover:scale-[1.02] transition-colors">
                <div className="bg-gradient-to-br from-amber-500 to-amber-600 text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl mb-4 shadow-lg mx-auto">
                  {step.step}
                </div>
                <h3 className="text-white font-semibold mb-2 text-lg text-center">{step.title}</h3>
                <p className="text-gray-400 text-sm text-center">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Dots Indicator */}
      <div className="flex justify-center gap-2 mt-6">
        {steps.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentStep(index)}
            className={`w-2 h-2 rounded-full transition-all ${
              index === currentStep 
                ? 'bg-amber-500 w-8' 
                : 'bg-slate-700 hover:bg-slate-600'
            }`}
            aria-label={`Go to step ${index + 1}`}
          />
        ))}
      </div>

      {/* Progress Bar */}
      <div className="mt-4 bg-slate-800 rounded-full h-1 overflow-hidden">
        <div 
          className="bg-gradient-to-r from-amber-500 to-amber-600 h-full transition-all duration-500 ease-in-out"
          style={{ width: `${((currentStep + 1) / steps.length) * 100}%` }}
        />
      </div>
    </div>
  );
};

export default ProcessSlider;